import ArrowWithTail from "@/assets/icons/ArrowWithTail";
import classes from "./ImageContainerCard.module.scss";
import Image from "next/image";
import Link from "next/link";

type ImageContainerCardProps = {
  news: any;
};

export default function ImageContainerCard({ news }: ImageContainerCardProps) {
  return (
    <div className={classes["card-container"]}>
      <div className={classes["image-wrapper"]}>
        <div className={classes["image"]}>
          <Image
            src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/${news.imageUrl}`}
            alt="Trending News Image"
            width={300}
            height={300}
          />
        </div>
        <div className={classes["overlay"]}>
          <div className={classes["header"]}>
            <div className={classes["titles-container"]}>
              <span className={classes.title1}> {news.categoryName}</span>
            </div>
            <p className={classes.description}>{news.title}</p>
          </div>
          <Link 
            href={`/article/${news.slug}`} 
            className={classes["read-more"]}
            rel="noopener noreferrer"
          >
            Read More
            <span>
              <ArrowWithTail rotation={360} color={"#0060dd"} />
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
}
